import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import Buefy from "buefy";
import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag"
import "./assets/scss/app.scss";

Vue.use(Buefy);
Vue.use(VueAnalytics, {
  id: "UA-140821660-2",
  autoTracking: {
    screenview: true
  }
});
Vue.use(VueGtag, {
  config:{
    id:"G-367088996"
  },
  appName: "qantuppi",
  pageTrackerScreenviewEnabled: true
})
Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
